import { Chip, Stack, Typography } from "@mui/material";

import CreditsDescription from "./CreditsDescription";
import styles from "./styles";

const CreditsHeader = () => {
  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1} sx={styles.header}>
        <Typography variant="h6" component="div" sx={styles.title}>
          ⚡ AI Personalization Credits
        </Typography>
        <Chip label="Never expires" size="small" sx={styles.expiresChip} />
      </Stack>

      <CreditsDescription />
    </>
  );
};

export default CreditsHeader;
